import React from 'react';
import './versionsDiff.css';

/**
 * Renders server-computed word-diff segments (`{type: equal|added|removed, text}`).
 *
 * `view` picks the perspective:
 *  - `both` — merged diff (Changes Summary): equal plain, removed struck-through
 *    on red, added on green.
 *  - `from` — the old version's text: equal + removed segments only.
 *  - `to`   — the new version's text: equal + added segments only.
 *
 * `plain` keeps the per-view segment filtering but renders unstyled text
 * (no highlight colors, no strikethrough) — used for the per-version
 * sections in the Record Diff modal.
 */
const segmentsForView = (segments, view) =>
  segments.filter((segment) => {
    if (segment.type === 'equal') return true;
    if (view === 'from') return segment.type === 'removed';
    if (view === 'to') return segment.type === 'added';
    return true;
  });

/** Plain text of one view's segments (e.g. for copy-to-clipboard). */
export const diffPlainText = (segments, view = 'both') => {
  if (!Array.isArray(segments)) return '';
  return segmentsForView(segments, view)
    .map((segment) => segment.text)
    .join(' ');
};

const DiffText = ({ segments, view = 'both', plain = false }) => {
  if (!Array.isArray(segments) || segments.length === 0) return null;

  const visible = segmentsForView(segments, view);

  return (
    <span className="vdm-diff-text">
      {visible.map((segment, index) => {
        const classNames = ['vdm-diff-segment'];
        if (!plain) {
          if (segment.type === 'added') classNames.push('vdm-diff-added');
          if (segment.type === 'removed') classNames.push('vdm-diff-removed');
        }
        return (
          <React.Fragment key={index}>
            {index > 0 ? ' ' : ''}
            <span className={classNames.join(' ')}>{segment.text}</span>
          </React.Fragment>
        );
      })}
    </span>
  );
};

export default DiffText;
